import { useQuery } from 'query';

import { loadUserPermissions } from '../sources/user';
import { permissions } from './queryKeyFactory';

export const useUserPermissions = () => {
  return useQuery(
    permissions(),
    async () => {
      return loadUserPermissions();
    },
    {
      onError: () => {
        //skip error handling
      },
    }
  );
};
